import { render } from "./v-loading.vue?vue&type=template&id=bad4d41c&scoped=true"
import script from "./v-loading.vue?vue&type=script&lang=js"
export * from "./v-loading.vue?vue&type=script&lang=js"

import "./v-loading.vue?vue&type=style&index=0&id=bad4d41c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad4d41c"]])

export default __exports__